import { kebabCase } from 'change-case'
import _ from 'lodash'

import { TooltipProps } from './types'

export const prepareCypressKey = (content: TooltipProps['content']): string => {
  const text = _.isArray(content) ? content[0] : content

  return kebabCase(text.slice(0, 10).toLocaleLowerCase())
}
